<template>
  <div class="loginAll">
    <div class="login" v-html="companyProfileInfo" v-if="code == 0">
      
    </div>
    <div class="login" v-if="code == 1">
      <div class="img">
        <img src="../../static/bottomLogin.png" />
      </div>
      <div class="lianx txt_a_c">公司邮箱：{{email}}</div>
      <div class="lianx txt_a_c">联系方式：{{phone}}</div>
      <div class="lianx txt_a_c">联系方式：010—52480940</div>
    </div>
  </div>
</template>

<script>
  // 引入共用的css
	import "../components/css/component.css";
  import "../components/css/input.css";

  // 调用的接口
  import { getAboutUsInfo } from '@/request/api.js';
  
  export default {
    name: 'aboutUs',
    data () {
      return {
        code: null,
        email: '', // 邮箱
        phone: '', // 手机号
        companyProfileInfo: ''
      }
    },

    mounted() {
      this.code = localStorage.getItem('aboutCode');
      // 获取公司简介
      this.getCompanyProfile();
    },

    computed:{
      
    },

    methods:{
      // 获取公司简介
      getCompanyProfile() {
        // 用户点击雪场获取的id
        var aboutCode = localStorage.getItem('aboutCode');
        // 调用获取公司简介接口
        getAboutUsInfo().then(res => {
          if(res.code === 0) {
            if(parseInt(aboutCode) == 0) {
              // 关于我们
              this.companyProfileInfo = res.data.desc;
            }else if(parseInt(aboutCode) == 1) {
              // 联系我们
              let row = res.data;
              this.email = row.email; // 邮箱
              this.phone = row.service_hotline; // 手机号
            }
          }
        })
      }
    }
  }
</script>

<!-- 样式 -->
<style scoped lang="scss">
  .loginAll {
    min-width: 1200px;
    height: 100vh;
    display: flex;
    align-items: center;
    // 框
    &> .login {
      width: 800px;
      margin: 0 auto;
      text-align: justify;
      padding: 30px 30px;
      border: 1px solid #0f7dff;
      line-height: 30px;
      border-radius: 10px;
      min-height: 400px;
      &p {
        line-height: 22px;
      }
    }
  }

  .img {
    height: 56px;
    width: 400px;
    margin: 0 auto;
    margin-top: 100px !important;
    margin-bottom: 100px !important;
  }

  .lianx {
    font-size: 14px;
    font-family: 微软雅黑, sans-serif;
  }
</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue